const _excluded = ["setEnabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getAdminConstructionApiUrl } from '@adsk/acs-sc-web-platform-api';
import { useGetAllPaginatedData, CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';
import { useCurrentProjectId } from './CurrentProjectIdContext';
import { removeOldDuplicatesBy } from './helpers/removeOldDuplicatesBy';
/**
 * Context for users list.
 */
const DeletedUsersContext = getOrCreateGlobalContext(CONTEXT_NAMES.DeletedUsersContext);
const PAGE_LIMIT = 200;
const useDeletedUsersContext = () => {
  const contextValue = useContext(DeletedUsersContext);
  const hook = 'useDeletedUsers';
  const provider = 'DeletedUsersProvider';
  if (!contextValue) {
    console.error("".concat(hook, " must be used within a ").concat(provider));
  }
  return contextValue || {};
};
export const useDeletedUsers = options => {
  const _useDeletedUsersConte = useDeletedUsersContext(),
    {
      setEnabled
    } = _useDeletedUsersConte,
    rest = _objectWithoutProperties(_useDeletedUsersConte, _excluded);
  const shouldFetchDeletedUsers = !(options !== null && options !== void 0 && options.disable);
  useEffect(() => {
    if (setEnabled) {
      setEnabled(shouldFetchDeletedUsers);
    }
  }, [shouldFetchDeletedUsers, setEnabled]);
  return _objectSpread(_objectSpread({}, rest), {}, {
    loading: options !== null && options !== void 0 && options.disable ? false : rest.loading
  });
};
export const DeletedUsersProvider = _ref => {
  let {
    children
  } = _ref;
  const [enabled, setEnabled] = useState(false);
  const projectId = useCurrentProjectId();
  const adminApiUrl = getAdminConstructionApiUrl();
  const url = enabled && projectId ? "".concat(adminApiUrl, "/v1/projects/").concat(projectId, "/users?filter[status]=deleted&limit=").concat(PAGE_LIMIT) : '';
  const {
    loading: loadingData,
    error,
    data: dataFromBE,
    retry
  } = useGetAllPaginatedData({
    url
  });
  const data = useMemo(() => {
    return dataFromBE && removeOldDuplicatesBy(dataFromBE.flatMap(usersPages => usersPages.results), item => item.id);
  }, [dataFromBE]);
  const loading = loadingData || !enabled;
  const value = useMemo(() => ({
    data,
    loading,
    error,
    retry,
    setEnabled: enabled ? undefined : setEnabled
  }), [data, loading, error, retry, enabled]);
  return /*#__PURE__*/React.createElement(DeletedUsersContext.Provider, {
    value: value
  }, children);
};
DeletedUsersProvider.displayName = 'DeletedUsersProvider';
DeletedUsersProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node
};
//# sourceMappingURL=DeletedUsers.js.map